export default __webpack_public_path__ + "static/media/medium.2d71e80d.svg";